// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GatedResourceForm_wrap__ZGcmu"};